module.exports = __webpack_public_path__ + "img/anniv.8e835338.png";